var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlenzyLogoShort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_74_15",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7876 0H0V39.8597H29.7876V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_74_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4745 2.03778C11.4745 2.03778 5.26379 11.3651 14.5928 20.6837C23.9218 30.0024 30.1395 33.1069 29.5436 36.3347C28.9477 39.5625 6.2383 44.1175 4.67655 30.1326C4.67655 30.1326 -0.833957 8.85819 11.4745 2.03778Z",
    fill: "#0B3453"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6801 38.663C11.6801 38.663 4.0017 30.5013 11.6471 19.7581C19.2925 9.01498 24.9057 4.91764 23.7802 1.83429C22.6547 -1.24907 -0.496212 -1.95543 0.294718 12.0941C0.294718 12.0941 -1.59295 33.9894 11.6801 38.663Z",
    fill: "url(#paint0_linear_74_15)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_74_15",
    x1: 28.6299,
    y1: -7.56095,
    x2: -7.64608,
    y2: 42.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21869,
    stopColor: "#0C5893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29464,
    stopColor: "#0D69A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42525,
    stopColor: "#0F80BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5653,
    stopColor: "#1090CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#119AD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91804,
    stopColor: "#119DD9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlenzyLogoShort);
export default __webpack_public_path__ + "static/media/glenzyLogo_short.be1184be06e40a462513468a48013b75.svg";
export { ForwardRef as ReactComponent };